export class TDSDate extends Date {
    static fromString(s) {
        return new TDSDate(Date.parse(s));
    }

    format(query) {
        query = query.replace("YYYY", this.getFullYear());
        query = query.replace("MM", this.getMonth() + 1 < 10 ? "0" + (this.getMonth() + 1) : this.getMonth() + 1);
        query = query.replace("DD", this.getDate() < 10 ? "0" + this.getDate() : this.getDate());
        query = query.replace("hh", this.getHours() < 10 ? "0" + this.getHours() : this.getHours());
        query = query.replace("mm", this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes());
        return query;
    }
}